/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/* eslint-disable radix */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { uniqueId } from 'lodash'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'
import { Link } from 'react-router-dom'
import { formatToBR } from '../../../utils/date'
import * as formatters from '../../../utils/formats'
import BoxRounded from '../BoxRounded/BoxRounded'
import Indicator from '../Indicator/Indicator'
import Text from '../Text/Text'
import Flex from '../Flex/Flex'
import Tag from '../Tag/Tag'
import styles from './boxIndicatorWithFilter.module.scss'

const BoxIndicatorWithFilter = (props) => {
  const { indicator, margin, height, onClick } = props

  const [current, setCurrent] = useState(2)

  const { valueMinimum, valuePenult, value, formatId } = indicator

  const newValues = {
    valueMinimum: formatters.formatIndicatorsValueForType(
      valueMinimum,
      formatId
    ),
    valuePenult: formatters.formatIndicatorsValueForType(valuePenult, formatId),
    value: formatters.formatIndicatorsValueForType(value, formatId)
  }

  const minimum = newValues.valueMinimum
  const penult = newValues.valuePenult
  const actual = newValues.value

  const bigger = Math.max(
    parseInt(minimum.value),
    parseInt(penult.value),
    parseInt(actual.value)
  )

  const collection = [
    {
      name: 'Mínimo',
      value: minimum.value,
      percent: (parseInt(minimum.value) * 100) / bigger
    },
    {
      name: 'Anterior',
      value: penult.value,
      percent: (parseInt(penult.value) * 100) / bigger
    },
    {
      name: 'Atual',
      value: actual.value,
      percent: (parseInt(actual.value) * 100) / bigger
    }
  ]

  const currentValue = formatters.formatIndicatorsValueForType(
    collection[current].value,
    formatId
  )

  const BoxIndicatorWithFilterStyles = {}

  if (height) BoxIndicatorWithFilterStyles.height = height

  return (
    <BoxRounded margin={margin} height="360px" padding="24px 27px 27px 24px">
      <div
        className={styles.container}
        id="container-box"
        style={BoxIndicatorWithFilterStyles}
      >
        <Flex column>
          <Text color="gray" variation="dark" size="xs">
            {indicator.title}
          </Text>
          <Text color="gray" variation="light" size="xxs">
            {indicator.subtitle}
          </Text>
        </Flex>
        <div className={styles.content}>
          <Flex column alignItems="center">
            <Text
              color="red"
              variation="light"
              fontWeight="800"
              size="xs"
              uppercase
            >
              {collection[current].name}
            </Text>
            <Flex alignItems="center">
              {!!currentValue.prefix && (
                <Text
                  font="custom"
                  color="red"
                  variation="light"
                  size="xxs"
                  fontWeight="400"
                  margin="0px 10px 0px 0px"
                >
                  {currentValue.prefix}
                </Text>
              )}

              <Text
                font="custom"
                color="red"
                variation="light"
                size="md"
                fontWeight="400"
                value={`${currentValue.formatted}`}
              />

              {!!currentValue.sufix && (
                <Text
                  font="custom"
                  color="red"
                  variation="light"
                  size="xxs"
                  fontWeight="400"
                  margin="0px 10px 0px 0px"
                >
                  {currentValue.sufix}
                </Text>
              )}
              <Flex column alignItems="flex-start">
                {current === 1 && (
                  <>
                    {valuePenult < valueMinimum && (
                      <MdKeyboardArrowDown color="#FDD98D" />
                    )}
                    {valuePenult >= valueMinimum && (
                      <MdKeyboardArrowUp color="#B3E5B3" size={15} />
                    )}
                  </>
                )}
                {current === 2 && (
                  <>
                    {value >= valuePenult && (
                      <MdKeyboardArrowUp color="#B3E5B3" size={15} />
                    )}
                    {value < valuePenult && (
                      <MdKeyboardArrowDown color="#FDD98D" />
                    )}
                  </>
                )}
              </Flex>
            </Flex>
          </Flex>
          <div className={styles.indicatorsContainer}>
            {collection.map((item, i) => (
              <Indicator
                key={uniqueId()}
                percent={item?.percent ? item.percent : 0}
                active={current === i}
              />
            ))}
          </div>
          <div className={styles.divTags}>
            <Tag
              small
              size="xxs"
              text="Mínimo"
              white
              outlined
              active={current === 0}
              onClick={() => setCurrent(0)}
            />
            <Tag
              small
              size="xxs"
              text="Anterior"
              white
              outlined
              active={current === 1}
              onClick={() => setCurrent(1)}
            />
            <Tag
              small
              size="xxs"
              text="Atual"
              active={current === 2}
              white
              outlined
              onClick={() => setCurrent(2)}
            />
          </div>
        </div>
        <Flex alignItems="center" justifyContent="space-between">
          <Text color="gray" variation="light" size="xxs">
            {`${indicator?.periodicityName}, ${formatToBR(
              indicator.updatedAt
            )}`}
          </Text>
          {indicator?.hasDetails && (
            <Link
              to={indicator.page}
              onClick={() => {
                onClick({
                  indicator,
                  currentValue,
                  name: collection[current]?.name
                })
              }}
            >
              <Text font="custom" color="gray" variation="dark" size="xxs">
                ver mais
              </Text>
            </Link>
          )}
        </Flex>
      </div>
    </BoxRounded>
  )
}

BoxIndicatorWithFilter.defaultProps = {
  margin: null,
  onClick: null,
  height: ''
}

BoxIndicatorWithFilter.propTypes = {
  margin: PropTypes.string,
  height: PropTypes.string,
  indicator: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    updatedAt: PropTypes.string,
    page: PropTypes.string,
    hasDetails: PropTypes.bool,
    periodicityName: PropTypes.string,
    periods: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        type: PropTypes.number,
        decrease: PropTypes.bool
      })
    )
  }).isRequired,
  onClick: PropTypes.func
}

export default BoxIndicatorWithFilter
